import AxiosInstance from "./api";

export const JournalVoucher8Service = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/journal-voucher-8s/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/journal-voucher-8s/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/journal-voucher-8s", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/journal-voucher-8s/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/journal-voucher-8s/" + id);
  },

  preview: async (params) => {
    return await AxiosInstance.get("/private/journal-voucher-8s/preview", {
      params,
    });
  },

  sync: async (params) => {
    return await AxiosInstance.post("/private/journal-voucher-8s/sync", null, {
      params,
    });
  },
};
